
(function($) {



    $(function($){

        $('.date-item-picker').datetimepicker({
            locale: moment.locale('sl'),
            format: 'L'
        });

		var preload = $('<img />',
             { id: 'preload',
               src: localize.assets + 'icons/spinner.gif', 
               width: 300
             });


        $('.switch_select').on('change', function(e){
                var targetLayer = $(e.target).data('target');
                var targetSelector = '.' + $(e.target).val();
                if($(targetLayer).children(targetSelector).length > 0) {
                    $(targetLayer).children(targetSelector).siblings().hide().attr('disabled', true);
					$(targetLayer).children(targetSelector).siblings().find('.form-control').attr('disabled', true);
					//console.log($(targetLayer).children(targetSelector).siblings().find('.form-control').val());
                    $(targetLayer).children(targetSelector).show().attr('disabled', false);

					$(targetLayer).children(targetSelector).find('.form-control').attr('disabled', false);
                }
            
        }).trigger('change');





		var savedData;
		$('#econtainers').on('submit', function(e){
			//e-zabojnik start
			e.preventDefault();
			var content_container = $(this).data('content');

			$("#panel_container_arrival").hide(300);
			$("#panel_container_operations").hide(300);
			$("#panel_container_departure").hide(300);
			$('#preload').show();
			$('.error-message').hide();
			
			$("#container_arrival").empty();
			$("#container_operations").empty();
			$("#container_departure").empty();
			
			$.ajax({
				method : 'POST',
				data: $(this).serializeArray(),
				beforeSend: function(){
					$(content_container).addClass('loading');
					//preload.appendTo($(content_container));
				},
				url: localize.ajaxurl,
				dataType: "json"	
			}).done(function(data, textStatus, dataType){
				///console.log(data);
				if(textStatus == 'notmodified'){
					data = savedData;
				}else{
					savedData = data;	
				}
				var arrivedFrom = data.allArrays.arrival[8].value;
			
				if(arrivedFrom == 'K'){
					//Tovornjak
					$("#container-image-arrival").removeClass('container-image-boat');
					$("#container-image-arrival").removeClass('container-image-train');
					$("#container-image-arrival").addClass('container-image-truck');
				} else if(arrivedFrom == 'L'){
					//Ladja
					$("#container-image-arrival").removeClass('container-image-truck');
					$("#container-image-arrival").removeClass('container-image-train');
					$("#container-image-arrival").addClass('container-image-boat');

				} else if(arrivedFrom == 'V'){
					//Vlak
					$("#container-image-arrival").removeClass('container-image-boat');
					$("#container-image-arrival").removeClass('container-image-truck');
					$("#container-image-arrival").addClass('container-image-train');
				} else{
					$("#container-image-arrival").removeClass('container-image-boat');
					$("#container-image-arrival").removeClass('container-image-truck');
					$("#container-image-arrival").removeClass('container-image-train');
					$("#container-image-arrival").addClass('container-image-cell');
				}
				
				if(data.allArrays.departure){
					var goingTo = data.allArrays.departure[9].value;
					if(goingTo == 'K'){
						$("#container-image-departure").removeClass('container-image-boat');
						$("#container-image-departure").removeClass('container-image-train');
						$("#container-image-departure").addClass('container-image-truck');
					} else if(goingTo == 'L'){
						$("#container-image-departure").removeClass('container-image-truck');
						$("#container-image-departure").removeClass('container-image-train');
						$("#container-image-departure").addClass('container-image-boat');
					} else if(goingTo == 'V'){
						$("#container-image-departure").removeClass('container-image-boat');
						$("#container-image-departure").removeClass('container-image-truck');
						$("#container-image-departure").addClass('container-image-train');
					} else{
						$("#container-image-departure").removeClass('container-image-boat');
						$("#container-image-departure").removeClass('container-image-truck');
						$("#container-image-departure").removeClass('container-image-train');
						$("#container-image-departure").addClass('container-image-cell');
					}
				}
				
				$("#container_arrival").append(data.tableAll.arrival);
				$("#container_operations").append(data.table_operations);
				$("#container_departure").append(data.tableAll.departure);
				
				$("#panel_container_arrival").show(600);
				if(data.allArrays.operations != null){
					$("#panel_container_operations").show(600);
				}
				if(data.allArrays.departure){
					$("#panel_container_departure").show(600);
					$("#panel_container_arrival").removeClass("single_box");
				}else{
					$("#panel_container_arrival").addClass("single_box");	
				}

				$(content_container).removeClass('loading');
				
			}).fail(function(err){
				//console.log('error:');
				//console.log(err);
				//$('#preload').hide();
			});
			//e-zabojnik end
		});


		const $operations_table = $("#operations_table");

		var getOperationsPlan = function(){
			
			$.ajax({
				url: localize.ajaxurl + '?action=getOperationsPlan',
				dataType: "json",
				beforeSend: function(){
					//$('#preload').show();
					$operations_table.addClass('loading');
					
				}
			}).done(function(data){
				//console.log(data);
				//$('#preload').hide();
				$('#typehead_search').show();
				$operations_table.append(data.table);
				$operations_table.removeClass('loading');
				startTypeheadSearch(data.search);
			}).fail(function(err){
				//console.log('error', err);
			});
		};
		
		
		if($operations_table.length > 0) {
			getOperationsPlan();
		}

		var startTypeheadSearch = function(data){
			var type = $('#typehead_search .typehead').typeahead(
				{
					highlight: true
				},
				{
					name: 'tic',
					source: substringMatcher(data.aTic),
					limit: 200,
					templates: {
						header: data.ticTitle
					}
				},
				{
					name: 'ship',
					source: substringMatcher(data.aShip),
					limit: 200,
					templates: {
						header: data.shipTitle
					},
				},
				{
					name: 'sName',
					source: substringMatcher(data.aSname),
					limit: 200,
					templates: {
						header: data.snameTitle
					}
				}
			);
			type.on('typeahead:selected', function(evt, item){
				//console.log(item);
		
				//$op_table
			  $('#operations_table tbody tr').each(function(i, ele){
				  var tic = $(ele).data('tic');
				  var ship = $(ele).data('ship');
				  var sname = $(ele).data('sname');
				  if(item != '' && tic != item && ship != item && sname != item){
					  $(ele).hide();
				  }else{
					  $(ele).show();
				  }
		  });
		  $('#typehead_search .typehead').on('change', function(evt, item){
		
				$('#operations_table > tbody > tr').each(function(i, ele){
					$(ele).show();
				});
		  });
		
			});
		};
		
		var substringMatcher = function(strs) {
		  return function findMatches(q, cb) {
			var matches, substrRegex;
			// an array that will be populated with substring matches
			matches = [];
			// regex used to determine if a string contains the substring `q`
			substrRegex = new RegExp(q, 'i');
			// iterate through the pool of strings and for any string that
			// contains the substring `q`, add it to the `matches` array
			$.each(strs, function(i, str) {
			  if (substrRegex.test(str)) {
				matches.push(str);
			  }
			});
			cb(matches);
		  };
		};
		
		//Najave ladij, plan pilotaž in stanje na privezih

        $('form.api-form').on('submit', function(e){
            e.preventDefault();
            console.log('form event', e);
            //console.log('serialData', $(e.target).serializeArray());
			var target_container = $(e.target).data('content');
			var form_type = $(e.target).attr('name');
			var target_content = $(e.target).next('.tab-inner-content'); 
			if(!form_type) return 'type not defined';

			return new Promise((resolve, reject) => {

				$.ajax({
					'method' : 'POST',
					'url' : localize.ajaxurl + '?action=' + form_type,
					'dataType' : "json",
					'beforeSend' : function() {
						// setting a timeout
						//preload.appendTo(target_content);
						$(target_content).addClass('loading');
					},
					'data': $(e.target).serializeArray(),
					'success': function (payload) {
						//payload = JSON.parse(payload);
						//console.log(payload);

						$(target_content).html(payload.table);
						$(target_content).removeClass('loading');
						//callback(JSON.parse(payload));
						resolve(payload);
					},
					'complete': function(response){
						//submitbox.removeClass('preloading');
					}
				}).fail(function(err) {
               
					// Reject the Promise with error message to show as content
					reject( "An error loading the resource" );
		   
					// Hide the loader
				});


			});


    }).trigger('submit');



$(function(e){

	$(".switch_select").on('change', function(){
		var selected = $(this).data("inputselector");
		$("."+selected+"_input_container").removeClass("active_input");
		var value = $(this).val();
		$("#in_"+value).addClass("active_input");
	});
	$(".input-group-addon").on('click', function(){
		$(this).prev('input').trigger('focus');
	});
});



});
   
})( jQuery );